<cm-routed-dialog [dialogSize]="DialogSize.Small">
    <ng-container cm-overlay-content>
        <cm-details-dialog-layout [loadError]="$loadError()" [isLoaded]="!!$item()">
            <ng-container cm-title>
                <cm-title-section
                    [title]="$title()"
                    [iconClass]="'far fa-tag'"
                    [isLoaded]="$item() !== undefined"
                    [canEdit]="$can().update.tag($item(), 'name')"
                    (onChanged)="updateItem({name: $event})"
                    (onClosed)="closeModal()"
                ></cm-title-section>
            </ng-container>
            <ng-container cm-main>
                <cm-tag-thumbnail [tag]="$item()"></cm-tag-thumbnail>
                <cm-section>
                    <ng-container cm-icon><i class="far fa-paperclip"></i></ng-container>
                    <ng-container cm-title> Assignments</ng-container>
                    <ng-container cm-content>
                        <cm-tag-assignments [tagId]="$item()?.id ?? ''" [canDelete]="$can().update.tag($item())"></cm-tag-assignments>
                    </ng-container>
                </cm-section>
            </ng-container>
            <ng-container cm-sidebar>
                <cm-input-container [cmIsLoading]="!$item()">
                    <ng-container cm-inline-label> Name:</ng-container>
                    <ng-container cm-input>
                        <cm-string-input [value]="$item()?.name ?? ''" (valueChange)="updateItem({name: $event})"></cm-string-input>
                    </ng-container>
                </cm-input-container>
                <cm-input-container [cmIsLoading]="!$item()">
                    <ng-container cm-inline-label> Color:</ng-container>
                    <ng-container cm-input>
                        <cm-color-input [hexValue]="$item()?.color ?? ''" (hexValueChange)="updateItem({color: $event})"></cm-color-input>
                    </ng-container>
                </cm-input-container>
                <cm-input-container [cmIsLoading]="!$item()">
                    <ng-container cm-top-label> Description:</ng-container>
                    <ng-container cm-input>
                        @if ($item()) {
                            <cm-native-input-text-area
                                [initialValue]="$item()?.description ?? ''"
                                [minRows]="4"
                                (valueChange)="updateItem({description: $event})"
                            >
                            </cm-native-input-text-area>
                        }
                    </ng-container>
                </cm-input-container>
                <cm-organization-select
                    [label]="'Customer'"
                    [updateOrganization]="updateItem.bind(this)"
                    [organizationId]="$item()?.organization?.id ?? null"
                    [showIfViewedByOwner]="false"
                ></cm-organization-select>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-select
                        [ngModel]="$item()?.type"
                        (valueChange)="updateItem({type: $event})"
                        placeholder="Type"
                        name="mTagType"
                        [disabled]="!$can().update.tag($item(), 'type')"
                    >
                        @for (tagType of $tagTypes(); track tagType.state) {
                            <mat-option [value]="tagType.state">{{ tagType.label }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @if ($item()?.type === TagType.MaterialRange) {
                    @if ($can().read.menu("generateFabricOverview")) {
                        <mat-form-field>
                            <mat-label>Overview Template Type</mat-label>
                            <mat-select
                                [ngModel]="this.$item()?.overviewTemplateType ?? 'NONE'"
                                (valueChange)="this.updateItem({overviewTemplateType: $event === 'NONE' ? null : $event})"
                                placeholder="Overview Template Type"
                                name="mOverviewTemplateType"
                                [disabled]="!$can().update.tag($item())"
                            >
                                @for (option of overviewTemplateTypeOptions; track option.value) {
                                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                    <cm-input-container>
                        <ng-container cm-inline-label> Full Width (in):</ng-container>
                        <ng-container cm-input>
                            <cm-numeric-input
                                [value]="$item()?.fullWidth ?? undefined"
                                [emptyValue]="null"
                                [convert]="cmToInchConvert"
                                [decimalPlaces]="2"
                                (valueChange)="updateItem({fullWidth: $event})"
                            ></cm-numeric-input>
                        </ng-container>
                    </cm-input-container>
                    <cm-input-container>
                        <ng-container cm-inline-label> Horiz Repeat (in):</ng-container>
                        <ng-container cm-input>
                            <cm-numeric-input
                                [value]="$item()?.repeatWidth ?? undefined"
                                [emptyValue]="null"
                                [convert]="cmToInchConvert"
                                [decimalPlaces]="2"
                                (valueChange)="updateItem({repeatWidth: $event})"
                            ></cm-numeric-input>
                        </ng-container>
                    </cm-input-container>
                    <cm-input-container>
                        <ng-container cm-inline-label> Vert Repeat (in):</ng-container>
                        <ng-container cm-input>
                            <cm-numeric-input
                                [value]="$item()?.repeatHeight ?? undefined"
                                [emptyValue]="null"
                                [convert]="cmToInchConvert"
                                [decimalPlaces]="2"
                                (valueChange)="updateItem({repeatHeight: $event})"
                            ></cm-numeric-input>
                        </ng-container>
                    </cm-input-container>
                    <cm-checkbox [value]="$item()?.railroaded ?? false" (valueChange)="updateItem({railroaded: $event})">
                        <ng-container> Railroaded</ng-container>
                    </cm-checkbox>
                }
                <cm-input-container [cmIsLoading]="!$item()">
                    <ng-container cm-inline-label> Created by:</ng-container>
                    <ng-container cm-input>
                        <cm-string-input [value]="$item()?.createdBy?.name ?? ''" [disabled]="true"></cm-string-input>
                    </ng-container>
                </cm-input-container>
            </ng-container>
        </cm-details-dialog-layout>
    </ng-container>
</cm-routed-dialog>
